import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Navbar from './components/Navbar';

import Footer from './components/Footer';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <>
      <Navbar/>
      <div className='min-h-screen bg-black text-white p-6'>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
        <Route path="privacy-policy" element={<PrivacyPolicy/>}/>
      </Routes>
      </div>
      <Footer/>
    </>
  );
}

export default App;
